import { render, staticRenderFns } from "./EditDealTabSection.vue?vue&type=template&id=0cc1ce4c&scoped=true&lang=pug&"
import script from "./EditDealTabSection.vue?vue&type=script&lang=js&"
export * from "./EditDealTabSection.vue?vue&type=script&lang=js&"
import style0 from "./EditDealTabSection.vue?vue&type=style&index=0&id=0cc1ce4c&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cc1ce4c",
  null
  
)

export default component.exports